export default __webpack_public_path__ + "static/truncation-dont-fc58c3f6d50d879a8065dc526a5796b2.png";